import { render, staticRenderFns } from "./page-zones.vue?vue&type=template&id=4c1cd1bc"
import script from "./page-zones.vue?vue&type=script&lang=js"
export * from "./page-zones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports